import { NaviTableColumnDef } from '@cp/src/components/NaviTable/interfaces';
import { Button, Tag } from '@navi/web-ui/lib/primitives';
import { AgencyStatusMap } from './constants/agencyStatusMap';
import styles from './Agency.module.scss';
import { AgencyStatus } from './interfaces/types';
import { RowClickEvent } from '@cp/src/components/interfaces';
import { AGENCY_TEAM_OPTIONS_MAP } from './constants/constants';
interface TableColumnDefsProps {
  handleEditAgencyDrawerClick: (event: RowClickEvent, refId: string) => void;
}

export const getAgencyTableColumnDefs = ({
  handleEditAgencyDrawerClick
}: TableColumnDefsProps): NaviTableColumnDef<any, any>[] => [
  {
    accessorKey: 'name',
    header: 'Name',
    size: 220,
    tooltip: true
  },
  {
    accessorKey: 'agencyTeam',
    header: 'Team',
    size: 140,
    cell: info => {
      const team = info?.row?.original?.agencyTeam as keyof typeof AGENCY_TEAM_OPTIONS_MAP;
      const teamLabel = AGENCY_TEAM_OPTIONS_MAP[team] || null;
      if (teamLabel) return teamLabel;
      return '-';
    }
  },
  {
    accessorKey: 'code',
    header: 'Code',
    size: 160
  },
  {
    accessorKey: 'serviceableStates',
    header: 'States',
    size: 240,
    tooltip: true,
    cell: info => {
      const stateList = info?.row?.original?.serviceableStates;
      if (!stateList?.length) return '-';
      return stateList.join(', ');
    }
  },
  {
    accessorKey: 'status',
    header: 'Status',
    size: 140,
    cell: info => {
      const status: string = info?.row?.original?.status;
      const { color = 'green', label } = AgencyStatusMap[status] || {};
      if (!label || !color) return '-';
      return (
        <Tag
          color={color}
          variant="transparent"
          label={label}
          labelClass={styles.lastFeedbackLabel}
        />
      );
    }
  },
  {
    accessorKey: 'allocatedCount',
    header: 'Allocated Cases',
    size: 160
  },
  {
    accessorKey: 'actions',
    header: 'Actions',
    size: 140,
    tooltip: info => {
      const status = info?.row?.original?.status;
      if (status) {
        if (status !== AgencyStatus.TERMINATED) return null;
        return { content: 'This agency has been terminated' };
      }
      return null;
    },
    cell: info => {
      const status = info?.row?.original?.status;
      const refId = info?.row?.original?.referenceId;
      const isDisabled = status === AgencyStatus.TERMINATED;
      return (
        <Button
          variant="text"
          className={isDisabled ? '' : 'hover:underline'}
          disabled={isDisabled}
          onClick={e => handleEditAgencyDrawerClick(e, refId)}
        >
          Edit details
        </Button>
      );
    }
  }
];
